import { render, staticRenderFns } from "./ThreadInput.vue?vue&type=template&id=f97f6568&scoped=true&"
import script from "./ThreadInput.vue?vue&type=script&lang=js&"
export * from "./ThreadInput.vue?vue&type=script&lang=js&"
import style0 from "./ThreadInput.vue?vue&type=style&index=0&id=f97f6568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97f6568",
  null
  
)

export default component.exports